<template>
  <div>
    <div class="bannerSlider">
      <Skeleton height="170px" width="100%" />
    </div>
  </div>
</template>

<script>
import Skeleton from '@/components/Skeleton/Skeleton';

export default {
  name: 'BannerSkeleton',
  components: { Skeleton },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
</style>
